import { render, staticRenderFns } from "./TabPrestadores.vue?vue&type=template&id=0167c4e0&scoped=true&"
import script from "./TabPrestadores.vue?vue&type=script&lang=js&"
export * from "./TabPrestadores.vue?vue&type=script&lang=js&"
import style0 from "./TabPrestadores.vue?vue&type=style&index=0&id=0167c4e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0167c4e0",
  null
  
)

export default component.exports